import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/tou_xiang.png'


const _withScopeId = n => (_pushScopeId("data-v-29570b9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_message" }
const _hoisted_2 = { class: "nav-tabbar" }
const _hoisted_3 = {
  key: 0,
  class: "tab1"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "img_left",
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("评论了我的项目需求 ")
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "tab1"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "img_left",
  src: _imports_0,
  alt: ""
}
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("回复了我的评论 ")
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "tab1"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "img_left",
  src: _imports_0,
  alt: ""
}
const _hoisted_27 = { class: "right" }
const _hoisted_28 = {
  key: 0,
  class: "name"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode("赞了我的项目需求 ")
const _hoisted_30 = { class: "time" }
const _hoisted_31 = {
  key: 3,
  class: "tab1 tab4"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  class: "right",
  style: {"width":"100%"}
}
const _hoisted_34 = { class: "name" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "time" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { ref, onMounted, onBeforeMount } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { addFeedBackApi } from "@/api/home"
import {
  commentMessageApi,
  deleteCommentMessageApi,
  replyMessageApi,
  deleteReplyApi,
  updateReadStatusApi,
  noticeApi,
  noticeReadApi,
  upvotesApi,
  messageNumApi,
  updateCommentReadStatusByIdApi,
  updateUpvoteReadStatusByIdApi
} from "@/api/my" // 接口
import { checkOffShelftApi } from "@/api/projectDemand" // 接口
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'messageList',
  setup(__props) {

const route = useRoute()
const active = ref(0)
const saoBaIsDisabled = ref(false)
const tabList = ref([{ name: "评论我的" }, { name: "回复我的" }, { name: "收到点赞" }, { name: "系统通知" }])
const tab1Ref: any = ref(null)
const tab2Ref: any = ref(null)
const tab3Ref: any = ref(null)
const tab4Ref: any = ref(null)
const tab1List: any = ref([])
const tab2List: any = ref([])
const tab3List: any = ref([])
const tab4List: any = ref([])
const params: any = ref({})
const datas = ref({})
onMounted(() => {
  // tab2Ref.value.onRefresh()
  // tab3Ref.value.onRefresh()
  // tab4Ref.value.onRefresh()
})
onBeforeMount(() => {
  getMessageNum()
})
const tabChange = (val: any) => {
  getMessageNum()
}
// 获取消息数量
const getMessageNum = () => {
  messageNumApi().then((res: any) => {
    if (res.code == 200) {
      datas.value = res.data
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 删除评论我的
const deleteItem = (item: any) => {
  showConfirmDialog({
    // title: "标题",
    message: "确认删除该评论吗？"
  })
    .then(() => {
      showLoadingToast({
        message: "删除中"
      })
      const submitForm = new FormData()
      submitForm.append("sfid", item.sfid)
      deleteCommentMessageApi(submitForm).then((res: any) => {
        closeToast()
        if (res.code == 200) {
          closeToast()
          showNotify({ type: "success", message: "删除成功" })
          // 刷新数据
          tab1List.value = []
          tab1Ref.value?.onRefresh()
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    })
    .catch(() => {
      // 取消
    })
}
// 删除回复我的
const deleteItemHF = (item: any) => {
  showConfirmDialog({
    // title: "标题",
    message: "确认删除该评论吗？"
  })
    .then(() => {
      showLoadingToast({
        message: "删除中"
      })
      const submitForm = new FormData()
      submitForm.append("sfid", item.sfid)
      deleteReplyApi(submitForm).then((res: any) => {
        closeToast()
        if (res.code == 200) {
          closeToast()
          showNotify({ type: "success", message: "删除成功" })
          // 刷新数据
          tab2List.value = []
          tab2Ref.value?.onRefresh()
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    })
    .catch(() => {
      // 取消
    })
}
// 获取头像
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}
// 角标
const badgeNum = (index: number) => {
  console.log(datas.value)
  switch (index) {
    case 0:
      if (datas.value.commentMeNum >= 1 && datas.value.commentMeNum <= 99) {
        return datas.value.commentMeNum
      } else if (datas.value.commentMeNum > 99) {
        return "99+"
      } else {
        return ""
      }
    case 1:
      if (datas.value.replyMeNum >= 1 && datas.value.replyMeNum <= 99) {
        return datas.value.replyMeNum
      } else if (datas.value.replyMeNum > 99) {
        return "99+"
      } else {
        return ""
      }
    case 2:
      if (datas.value.existUnreadUpvote == 1) {
        return true
      } else {
        return false
      }
    case 3:
      if (datas.value.existUnreadNotice == 1) {
        return true
      } else {
        return false
      }
    default:
      break
  }
}
// 跳转详情
const gotoDetailTab1 = (item: any) => {
  // 设置为已读状态
  const formDatas = new FormData()
  formDatas.append("ids", item.sfid) // 追加文件
  if (item.isRead != "1") {
    updateCommentReadStatusByIdApi(formDatas).then((res: any) => {
      if (res.code !== 200) {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
  if (item.isDelete == "1" || item.zt == "off-shelf") {
    showNotify({ type: "warning", duration: 800, message: "该项目需求已删除/已下架" })
  } else {
    // ***********************实时判断是否下架
    checkOffShelftApi(item.projectRequireSfid)
      .then((res: any) => {
        if (res.data) {
          showNotify({ type: "warning", duration: 800, message: "该项目需求已删除/已下架" })
        } else {
          // *********************
          //记录浏览量
          var datas = {
            originalSfid: item.sfid,
            type: "project"
          }
          addFeedBackApi(datas).then(() => {})
          router.push({ path: "/projectDemand/detail", query: { id: item.projectRequireSfid } })
        }
      })
      .catch(() => {
        //记录浏览量
        var datas = {
          originalSfid: item.sfid,
          type: "project"
        }
        addFeedBackApi(datas).then(() => {})
        router.push({ path: "/projectDemand/detail", query: { id: item.projectRequireSfid } })
      })
  }
}
const gotoDetailTab3 = (item: any) => {
  // 设置为已读状态
  const formDatas = new FormData()
  formDatas.append("ids", item.sfid) // 追加文件
  let newUrl: any = updateUpvoteReadStatusByIdApi
  if (item.isRead != "1") {
    newUrl(formDatas).then((res: any) => {
      if (res.code !== 200) {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
  if (item.isDelete == "1" || item.zt == "off-shelf") {
    showNotify({ type: "warning", duration: 800, message: "该项目需求已删除/已下架" })
  } else {
    // router.push({ path: "/projectDemand/detail", query: { id: item.originalSfid } })
    // ***********************实时判断是否下架
    checkOffShelftApi(item.originalSfid)
      .then((res: any) => {
        if (res.data) {
          showNotify({ type: "warning", duration: 800, message: "该项目需求已删除/已下架" })
        } else {
          //记录浏览量
          var datas = {
            originalSfid: item.sfid,
            type: "project"
          }
          addFeedBackApi(datas).then(() => {})
          router.push({ path: "/projectDemand/detail", query: { id: item.originalSfid } })
        }
      })
      .catch(() => {
        //记录浏览量
        var datas = {
          originalSfid: item.sfid,
          type: "project"
        }
        addFeedBackApi(datas).then(() => {})
        router.push({ path: "/projectDemand/detail", query: { id: item.originalSfid } })
      })
  }
}
// 扫把通知已读
const allRite = () => {
  showLoadingToast({
    message: "加载中"
  })
  saoBaIsDisabled.value = true
  try {
    updateReadStatusApi().then((res: any) => {
      saoBaIsDisabled.value = false
      if (res.code == 200) {
        closeToast()
        showNotify({ type: "success", message: "全部已读成功" })
        getMessageNum()
        // 刷新数据
        if (active.value == 0) {
          tab1List.value = []
          tab1Ref.value?.onRefresh()
        } else if (active.value == 1) {
          tab2List.value = []
          tab2Ref.value?.onRefresh()
        } else if (active.value == 2) {
          tab3List.value = []
          tab3Ref.value?.onRefresh()
        } else if (active.value == 3) {
          tab4List.value = []
          tab4Ref.value?.onRefresh()
        }
      } else {
        closeToast()
        showNotify({ type: "danger", message: res.message })
      }
    })
  } catch (err) {
    saoBaIsDisabled.value = false
  }
}
// 系统通知跳转详情页面
const systemNoticeDetail = (item: any) => {
  if (item.isDelete == "1") {
    showNotify({ type: "warning", duration: 800, message: "已删除" })
  } else {
    // 设置为已读状态
    const ids = item.sfid
    if (item.isRead != "1") {
      noticeReadApi(ids).then((res: any) => {
        if (res.code !== 200) {
          showNotify({ type: "danger", message: res.message })
        }
      })
      router.push({ path: "/systemNoticeDetail", query: { id: item.sfid } })
    } else {
      router.push({ path: "/systemNoticeDetail", query: { id: item.sfid } })
    }
  }
  // router.push({ path: "/systemNoticeDetail", query: { id: item.sfid } })
}

return (_ctx: any,_cache: any) => {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabbar, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        "active-color": "#000",
        fixed: false,
        onChange: tabChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tabbar_item, {
              badge: badgeNum(index),
              key: index,
              dot: (index == 2 && badgeNum(index)) || (index == 3 && badgeNum(index)),
              class: _normalizeClass(badgeNum(index) == '0' ? 'hideBadge' : '')
            }, {
              icon: _withCtx(() => [
                _createElementVNode("p", {
                  class: _normalizeClass([`p_${index}`, 'p_img'])
                }, null, 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["badge", "dot", "class"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (active.value === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ListWithRefreshAndLazyLoad, {
            ref_key: "tab1Ref",
            ref: tab1Ref,
            list: tab1List.value,
            "onUpdate:list": _cache[1] || (_cache[1] = ($event: any) => ((tab1List).value = $event)),
            params: params.value,
            getDataAPI: _unref(commentMessageApi),
            offset: 10,
            noDataText: "您还未收到消息哦~"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab1List.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["list-item flex-row", item.isRead != '1' ? 'setBackground' : '']),
                  key: i,
                  onClick: ($event: any) => (gotoDetailTab1(item))
                }, [
                  (item.commentHeadResourceDetail)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "img_left",
                        src: getImg(item.commentHeadResourceDetail?.sfid),
                        alt: ""
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(item.commentUserName), 1),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.commentContent), 1),
                    _createElementVNode("p", _hoisted_11, [
                      _createTextVNode(_toDisplayString(item.commentTime), 1),
                      _createElementVNode("span", {
                        onClick: _withModifiers(($event: any) => (deleteItem(item)), ["stop"])
                      }, "删除", 8, _hoisted_12)
                    ])
                  ])
                ], 10, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["list", "params", "getDataAPI"])
        ]))
      : (active.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(ListWithRefreshAndLazyLoad, {
              ref_key: "tab2Ref",
              ref: tab2Ref,
              list: tab2List.value,
              "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((tab2List).value = $event)),
              params: params.value,
              getDataAPI: _unref(replyMessageApi),
              offset: 10,
              noDataText: "您还未收到消息哦~"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab2List.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["list-item flex-row", item.isRead != '1' ? 'setBackground' : '']),
                    key: i,
                    onClick: ($event: any) => (gotoDetailTab1(item))
                  }, [
                    (item.commentHeadResourceDetail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "img_left",
                          src: getImg(item.commentHeadResourceDetail?.sfid),
                          alt: ""
                        }, null, 8, _hoisted_15))
                      : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(item.commentUserName), 1),
                        _hoisted_19
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.commentContent), 1),
                      _createElementVNode("p", _hoisted_21, [
                        _createTextVNode(_toDisplayString(item.commentTime), 1),
                        _createElementVNode("span", {
                          onClick: _withModifiers(($event: any) => (deleteItemHF(item)), ["stop"])
                        }, "删除", 8, _hoisted_22)
                      ])
                    ])
                  ], 10, _hoisted_14))
                }), 128))
              ]),
              _: 1
            }, 8, ["list", "params", "getDataAPI"])
          ]))
        : (active.value === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(ListWithRefreshAndLazyLoad, {
                ref_key: "tab3Ref",
                ref: tab3Ref,
                list: tab3List.value,
                "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((tab3List).value = $event)),
                params: params.value,
                getDataAPI: _unref(upvotesApi),
                offset: 10,
                noDataText: "您还未收到消息哦~"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab3List.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["list-item flex-row", item.isRead != '1' ? 'setBackground' : '']),
                      key: i,
                      onClick: ($event: any) => (gotoDetailTab3(item))
                    }, [
                      (item.commentHeadResourceDetail)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "img_left",
                            src: getImg(item.commentHeadResourceDetail?.sfid),
                            alt: ""
                          }, null, 8, _hoisted_25))
                        : (_openBlock(), _createElementBlock("img", _hoisted_26)),
                      _createElementVNode("div", _hoisted_27, [
                        (item.upvoteUserName)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                              _createElementVNode("span", null, _toDisplayString(item.upvoteUserName), 1),
                              _hoisted_29
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(item.upvoteTime), 1)
                      ])
                    ], 10, _hoisted_24))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list", "params", "getDataAPI"])
            ]))
          : (active.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(ListWithRefreshAndLazyLoad, {
                  ref_key: "tab4Ref",
                  ref: tab4Ref,
                  list: tab4List.value,
                  "onUpdate:list": _cache[4] || (_cache[4] = ($event: any) => ((tab4List).value = $event)),
                  params: params.value,
                  getDataAPI: _unref(noticeApi),
                  offset: 10,
                  noDataText: "您还未收到消息哦~"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab4List.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["list-item flex-row", item.isRead != '1' ? 'setBackground' : '']),
                        key: i,
                        onClick: ($event: any) => (systemNoticeDetail(item))
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, [
                            _createElementVNode("span", null, _toDisplayString(item.noticeTitle), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "content",
                            innerHTML: item.noticeContent
                          }, null, 8, _hoisted_35),
                          _createElementVNode("p", _hoisted_36, _toDisplayString(item.createTime), 1)
                        ])
                      ], 10, _hoisted_32))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list", "params", "getDataAPI"])
              ]))
            : _createCommentVNode("", true),
    _createVNode(_component_van_button, {
      class: "sao_ba",
      onClick: allRite,
      disabled: saoBaIsDisabled.value
    }, {
      default: _withCtx(() => [
        _hoisted_37
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})